// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ct-2";
export var aiChatCartContainerExit = "_ct-4";
export var aiChatContainerLarge = "_ct-0";
export var aiChatContainerSmall = "_ct-1";
export var aiChatIcon = "_ct-6";
export var slideInFromRight = "_ct-3";
export var slideOutToRight = "_ct-5";